import { ServicesManager } from '@core';

const getActiveViewportModality = (servicesManager: ServicesManager) => {
	const { displaySetService, viewportGridService } = servicesManager.services;
	const activeViewportId = viewportGridService?.getActiveViewportId() || null;
	const activeViewport = activeViewportId && viewportGridService?.getViewportState(activeViewportId);
	const displaySet =
		displaySetService &&
		activeViewport &&
		activeViewport.displaySetInstanceUIDs &&
		activeViewport.displaySetInstanceUIDs &&
		activeViewport.displaySetInstanceUIDs.length &&
		activeViewport.displaySetInstanceUIDs[0]
			? displaySetService.getDisplaySetByUID(activeViewport.displaySetInstanceUIDs[0])
			: undefined;

	// Modality of current displaySet
	const modality = displaySet?.Modality;

	return modality;
};

export default getActiveViewportModality;
